import axios from 'axios';

import { Route } from './types';

import { TRAVEL_DISTANCES } from '../endpoints';

export const getRoutes = () => axios.get<Route[]>(TRAVEL_DISTANCES);
export const getRoutePoints = (id: number) =>
  axios.get<string>(`${TRAVEL_DISTANCES}/${id}/points`);
//  new Promise<tempResolveType>((resolve) => resolve({ data: mockRoutesBase }));

export const deleteRoute = (id: number) =>
  axios.delete(`${TRAVEL_DISTANCES}/${id}`);
export const updateRoute = (route: Route) =>
  axios.put(`${TRAVEL_DISTANCES}/${route.id}`, route);
export const createRoute = (route: Route) =>
  axios.post(TRAVEL_DISTANCES, route);
